var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceOrderV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1309 12.6289C13.1425 12.7028 13.1494 12.7778 13.1494 12.8535C13.1494 13.2332 13.0001 13.598 12.7344 13.8691L11.9678 14.6357C11.6968 14.9013 11.3325 15.0497 10.9531 15.0498C10.8761 15.0498 10.7998 15.0413 10.7246 15.0293C10.8646 15.0866 11.0109 15.1289 11.1621 15.1504C11.5085 15.1996 11.8619 15.1481 12.1807 15.0039C12.511 14.8544 12.8929 14.9014 13.1758 15.1152L13.29 15.2168L15.9902 18.0127C15.9934 18.0158 15.9975 18.0175 16.002 18.0176C16.0066 18.0176 16.0113 18.016 16.0146 18.0127C16.018 18.0094 16.0195 18.0047 16.0195 18C16.0195 17.9954 16.0179 17.9906 16.0146 17.9873C16.0107 17.9834 16.0068 17.9796 16.0029 17.9756L13.291 15.167C13.0121 14.8781 12.9371 14.4479 13.1025 14.082C13.2468 13.7633 13.2982 13.4099 13.249 13.0635C13.2277 12.9136 13.1873 12.7678 13.1309 12.6289Z",
    stroke: "white",
    strokeWidth: 1.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93359 5H5.59961",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26628 8H5.59961",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18.1667H4.66667C4.22464 18.1667 3.80072 17.9911 3.48816 17.6785C3.17559 17.366 3 16.942 3 16.5V3.66667C3 3.22464 3.17559 2.80072 3.48816 2.48816C3.80072 2.17559 4.22464 2 4.66667 2H11.7525C12.0177 2 12.272 2.10536 12.4596 2.29289L16.0404 5.87377C16.228 6.06131 16.3333 6.31566 16.3333 6.58088V10",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceOrderV2);
export default __webpack_public_path__ + "static/media/serviceOrderV2.406c21ff7027c3b3fcf1489b8c8ab2d4.svg";
export { ForwardRef as ReactComponent };